<ng-container *transloco="let t">
  <div class="flex flex-col gap-2">
    <!-- Label -->
    @if (props.label) {
      <label [for]="id" class="font-semibold">
        {{ props.label }}
      </label>
    }

    <!-- File Download Buttons -->
    @if (hasFiles) {
      @for (item of allFiles; track item.file.fileName) {
        <app-transaction-attachment
          [transactionId]="props.transactionId"
          [file]="item.file"
          [parentEntry]="item.parentEntry"
          (deleted)="props.onAttachmentDeleted && props.onAttachmentDeleted(item.parentEntry)"
        />
      }
    } @else {
      <div
        class="text-sm text-gray-500 dark:text-gray-400 p-3 border border-surface-200 dark:border-surface-700 rounded bg-surface-50 dark:bg-surface-800"
      >
        {{ t("app.transactionDetails.noFilesUploaded") }}
      </div>
    }

    <!-- Description -->
    @if (props.description) {
      <div class="text-sm text-surface-600 dark:text-surface-200 mt-1">
        {{ props.description }}
      </div>
    }
  </div>
</ng-container>
